import { delay } from '@resn/gozer-misc';
import isSandbox from 'utils/is-sandbox';

export const setupPreloader = async () => {
    const Preloader = await import(/* webpackChunkName: "preloader" */ 'component/preloader');
    const preloader = await new Preloader.default().setup({
        options: {
            appendTo: document.body,
        },
    });
    preloader.show();
    return preloader;
};

export const setupDevUI = async () => {
    if (__ENV__ !== 'live' && __ENV__ !== 'prelive') {
        const DevAPI = await import(/* webpackChunkName: "dev-ui-api" */ 'dev/api');
        return await new DevAPI.default().setup({ options: { appendTo: document.body } });
    }
};

export const setupShell = async (preloader) => {
    // shell
    const Shell = await import(/* webpackChunkName: "shell" */ 'component/shell');
    const shell = await new Shell.default().setup({
        options: {
            appendTo: document.body,
            preloader,
            // whilePreloading, // Getting rid of this...
        },
    });
    return shell;
};
